import {createContext} from 'react';

import type {ConfigManager} from '@pexip/config-manager';
import type {AppConfig} from '../types';

export const ConfigContext = createContext<
    ConfigManager<AppConfig> | undefined
>(undefined);
